import { PARTS_FAILURE, PARTS_REQUEST, PARTS_SAVE_QUERY, PARTS_SUCCESS, PartsActionTypes, State } from "./types";

const initialState: State = {
  loading: false,
};

export function partsReducer(state = initialState, action: PartsActionTypes): State {
  switch (action.type) {
    case PARTS_SAVE_QUERY:
      return {
        ...state,
        query: action.payload,
      };

    case PARTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case PARTS_SUCCESS:
      return {
        ...state,
        parts: action.payload.data.map((p) => ({
          id: p.id,
          code: p.attributes.code,
          price: p.attributes.price,
          priceInt: p.attributes["price-int"],
          ruDescription: p.attributes["ru-description"],
          enDescription: p.attributes["en-description"],
        })),
        links: action.payload.links,
        meta: action.payload.meta,
        loading: false,
      };

    case PARTS_FAILURE:
      // Пустой список API возвращает с 404-й ошибкой
      if (action.payload.name === "ApiError" && action.payload.status === 404) {
        return {
          ...state,
          parts: action.payload.response,
          loading: false,
        };
      }

      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
